import { PiX } from "react-icons/pi";
import { TaskLink } from "../models/TaskLink";

export default function LinkTile({
  link,
  onDelete,
}: {
  link: TaskLink;
  onDelete?: () => void;
}) {
  return (
    <div className="flex items-center px-2 py-2 rounded-md">
      {link.image && (
        <img
          src={link.image}
          alt={link.title}
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
          className="h-12 w-12 rounded-md mr-2"
        />
      )}
      <div className="grow">
        <div
          className="font-bold line-clamp-1 link-hover cursor-pointer"
          onClick={() => {
            window.open(link.url, "_blank");
          }}
        >
          {link.title}
        </div>
        <div className="line-clamp-1 italic text-sm">{link.description}</div>
      </div>
      {onDelete && (
        <PiX
          className="w-6 cursor-pointer btn btn-circle btn-ghost"
          onClick={onDelete}
          size={14}
        />
      )}
    </div>
  );
}
